import { CreateGroupTask } from "../../types";

export const defaultValues = (data?: CreateGroupTask) => {
  return {
    mr_group_task_code: data?.mr_group_task_code ?? "",
    mr_group_task_name: data?.mr_group_task_name ?? "",
    description: data?.description ?? ""
  };
};